import Button from "./components/General/Button.vue";
import ButtonGroup from "./components/General/ButtonGroup.vue";

// Export components individually
export { Button, ButtonGroup };

// What should happen if the user installs the library as a plugin
function install(Vue) {
  Vue.component("ck-button", Button);
  Vue.component("ck-button-group", ButtonGroup);
}

// Export the library as a plugin
export default { install: install };
